<template>
    <!-- solid sales graph -->
    <div class="card bg-gradient-info">
        <div class="card-header">
            <h3 class="card-title">
                <i class="fas fa-file-invoice-dollar mr-1"></i>
                {{ texto == 1? 'Registro contable': 'Facturación' }}
            </h3>
            <i class="fas fa-info" style="float:right" @click="toggle($event)"></i>

        </div>
        <div class="card-body">
            <Chart type="line" :data="basicData" :options="basicOptions" />
            <OverlayPanel ref="info4">
                <h4 style="text-align:center">{{ texto == 1? 'Registro contable': 'Facturación' }}</h4>
                <p>Indica el total de {{ texto == 1? 'registros contables': 'facturas' }}/albaranes realizados por día<br>
                <ul>
                    <li>No tiene en cuenta la fecha del {{ texto == 1? 'registro contable': 'factura' }}/albarán,<br>
                        sino la <strong>fecha/hora de creación</strong> de la misma.</li>
                </ul>
                </p>
            </OverlayPanel>
        </div>
    </div>
</template>
<script>
import OverlayPanel from 'primevue/overlaypanel';

export default {
    components: {

        OverlayPanel,
    },
    data() {
        return {
            texto: localStorage.getItem('no_factura'),
            estadisticas:[],
            basicData: {
                labels: [],
                datasets: [
                    {
                        label: 'Base imponible',
                        data: [],
                        fill: false,
                        borderColor: '#FFFFFF',
                        tension: .4
                    }
                ]
            },
            basicOptions: {
                plugins: {
                    legend: {
                        labels: {
                            color: '#FFFFFF'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#FFFFFF'
                        },
                        grid: {
                            color: '#FFFFFF'
                        }
                    },
                    y: {
                        ticks: {
                            color: '#FFFFFF'
                        },
                        grid: {
                            color: '#FFFFFF'
                        }
                    }
                }
            }
        }
    },
    props:['datosestadisticas'],
    methods: {            
        toggle(event) {
            this.$refs.info4.toggle(event);
        },

    },
    watch: {
        datosestadisticas(value){
            this.estadisticas = value;
            this.basicData.labels = this.estadisticas.graficas.facturacion.labels;
            this.basicData.datasets[0].data = this.estadisticas.graficas.facturacion.facturacion;
        }
    },

}
</script>